/**
 * انتخاب‌های لابی که یادشان می‌مانَد.
 *
 * بازیکنی که هر شب حکمِ رایگان بازی می‌کند، نباید هر شب همان سه انتخاب را از
 * نو بکند. سه چیز ذخیره می‌شود — بازی، ورودیِ میز، و دو گزینه‌ی اتاق — و
 * رمزِ اتاق **عمداً نه**: چیزی که بین دو نفر رد و بدل می‌شود در مرورگر
 * نمی‌مانَد، و اتاقِ بعدی رمزِ خودش را می‌خواهد.
 *
 * جدا از خودِ لابی، چون این منطق است و نه نما: ذخیره‌ی کهنه‌ی یک بیلدِ قدیمی
 * نباید صفحه را بشکند، و آن را باید بشود بی رندرِ ری‌اکت آزمود.
 */
import { games } from "./games";

/** آینه‌ی economy.StakeLevels سمتِ سرور. */
export const STAKES: readonly bigint[] = [0n, 100n, 500n, 2000n];

export type Prefs = { game: string; stake: bigint; open: boolean; locked: boolean };

const KEY = "bazivan.hub";

export const DEFAULTS: Prefs = { game: "hokm", stake: 0n, open: false, locked: false };

/**
 * انتخاب‌های دفعه‌ی پیش.
 *
 * `urlGame` بر ذخیره می‌چربد: کسی که از صفحه‌ی شلم آمده، شلم می‌خواهد —
 * هرچقدر هم که دیشب حکم بازی کرده باشد.
 *
 * هر مقدارِ ناشناخته دور ریخته می‌شود و پیش‌فرض می‌نشیند. بازیِ حذف‌شده‌ای که
 * از ذخیره‌ی قدیمی برگردد، به سرور می‌رفت و «unsupported_game» می‌گرفت.
 */
export function loadPrefs(urlGame?: string | null): Prefs {
  const known = (id: unknown) => games.some((g) => g.id === id);
  const base: Prefs = { ...DEFAULTS, game: known(urlGame) ? String(urlGame) : DEFAULTS.game };

  let raw: string | null = null;
  try { raw = localStorage.getItem(KEY); } catch { /* حالتِ ناشناس */ }
  if (!raw) return base;

  try {
    const v = JSON.parse(raw) as Partial<Record<keyof Prefs, unknown>>;
    return {
      game: known(urlGame) ? String(urlGame) : known(v.game) ? String(v.game) : DEFAULTS.game,
      // سطحِ ناشناخته صفر می‌شود و نه «هرچه بود»: ورودیِ میز پول است.
      stake: STAKES.find((s) => String(s) === String(v.stake)) ?? DEFAULTS.stake,
      open: v.open === true,
      locked: v.locked === true,
    };
  } catch {
    return base;
  }
}

export function savePrefs(p: Prefs): void {
  // بیگ‌اینت در JSON نمی‌نشیند، پس رشته می‌رود.
  try { localStorage.setItem(KEY, JSON.stringify({ ...p, stake: String(p.stake) })); }
  catch { /* حالتِ ناشناس */ }
}
